import { Console } from '@plopix/js-console/dist/ts/Console';

export const Logger = new Console();
Logger.verbosity = 400;
Logger.logOnLoad();

export const handlerOmitComments = (omitComments = true): void => {
  Logger.verbosity = omitComments ? 400 : 0;
};
